const MAGICBUY_PROJECTS = ['mgb-pc', 'mgb-h5']
const PC_PROJECTS = ['pc', 'mgb-pc']
const H5_PROJECTS = ['h5', 'mgb-h5']
const H5_TEST_PACKAGE_PROJECTS = {
  h5: 'kkren-h5',
  'mgb-h5': 'mgb-h5',
}

export function isMagicbuyProject (project) {
  return MAGICBUY_PROJECTS.includes(project)
}

// 是否为 H5 端（巧巧郎 h5 / 买即可 mgb-h5），用于共享组件区分 PC 新分页与 H5 App 内跳转
export function isH5Project (project) {
  return H5_PROJECTS.includes(project)
}

export function getWebVersionHeaderName (project) {
  if (PC_PROJECTS.includes(project)) {
    return 'Pc-Ver'
  }
  if (H5_PROJECTS.includes(project)) {
    return 'H5-Ver'
  }
  return ''
}

// 不带 Pc-Ver / H5-Ver 版本头的接口：后端对这些接口回 *-H5VerOlder 会触发 APP 网页包强制更新，
// option/app 本身是更新流程的一环，登入／註冊／驗證碼／重設密碼在未登录态下不应被版本检查卡住
const WEB_VERSION_HEADER_SKIP_URL_PATTERNS = [
  'option/app',
  '/user/v1frontend/login/',
]

export function shouldSkipWebVersionHeader (url) {
  const target = String(url || '')
  return WEB_VERSION_HEADER_SKIP_URL_PATTERNS.some(pattern => target.indexOf(pattern) > -1)
}

export function shouldRestrictBatchTrackingNosToParentChild (project, edition) {
  return edition !== 's' && !isMagicbuyProject(project)
}

export function getProjectBrandName (project) {
  return isMagicbuyProject(project) ? '買即可' : '巧巧郎'
}

export function getH5TestPackageProject (project) {
  const testPackageProject = H5_TEST_PACKAGE_PROJECTS[project]
  if (!testPackageProject) {
    throw new Error(`不支持下载测试包的 H5 项目：${project}`)
  }
  return testPackageProject
}

export function canShowJybCoinFeatures (project) {
  return !isMagicbuyProject(project)
}

export function isJybCoinCoupon (coupon = {}) {
  const source = String(coupon.crSource || coupon.coinSource || coupon.source || '').toUpperCase()
  if (source === 'PCL') {
    return true
  }

  const text = [
    coupon.cpnCode,
    coupon.crCpnCode,
    coupon.cpnName,
    coupon.crSource,
    coupon.coinSource,
  ].filter(Boolean).join(' ').toLowerCase()

  return text.includes('jypointsub') ||
    text.includes('金巧幣') ||
    text.includes('金巧币')
}

export function filterJybCoinCoupons (coupons = [], project) {
  if (canShowJybCoinFeatures(project)) {
    return coupons
  }
  return coupons.filter(coupon => !isJybCoinCoupon(coupon))
}
